<template>
  <nav v-if="items.length > 0" class="app-breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumb mb-0">
      <li
        v-for="(item, index) in items"
        :key="`${item.label}-${index}`"
        class="breadcrumb-item"
        :class="{ active: index === items.length - 1 }"
        :aria-current="index === items.length - 1 ? 'page' : undefined"
      >
        <router-link v-if="item.to && index !== items.length - 1" :to="item.to">
          {{ item.label }}
        </router-link>
        <span v-else>{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { resolveBreadcrumbs } from '@/router/breadcrumbs'
import { cuentaCorrienteClienteNombre } from '@/composables/cuentaCorrienteContext'

const route = useRoute()

const items = computed(() => {
  const resolved = resolveBreadcrumbs(route)
  if (route.name !== 'CuentaCorriente' || !cuentaCorrienteClienteNombre.value || !resolved.length) {
    return resolved
  }

  return resolved.map((item, index) =>
    index === resolved.length - 1
      ? { ...item, label: `Cuenta corriente - ${cuentaCorrienteClienteNombre.value}` }
      : item
  )
})
</script>
